import { Flex, Text } from "@chakra-ui/react";
import { conditionsConfig } from "./conditions.config";
import { IconTemp, IconWind, IconSpeed, IconBumps, IconGrip } from 'icons';
type ConditionRangeProps = {
  text: string;
  textColor: string;
  backgroundColor: string;
}

const ConditionRange = ({ text, textColor, backgroundColor }: ConditionRangeProps) => {
  return (
    <Flex
      background={backgroundColor}
      borderRadius="4px"
      p="1"
    >
      <Text
        fontSize={{ base: '10px', md: '12px' }}
        lineHeight={{ base: '12px', md: '14px' }}
        fontWeight="600"
        color={textColor}
      >
        {text}
      </Text>
    </Flex>
  )
}

type ConditionItemProps = {
  type: keyof typeof conditionsConfig;
  variant: string;
  tbd?: boolean;
}

const conditionItemIcon = (label: string, tbd?: boolean) => {
  switch (label) {
    case 'Air':
      return <IconTemp __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} mr="-1" />;
    case 'Track':
      return <IconTemp __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} mr="-1" />;
    case 'Wind':
      return <IconWind __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} />;
    case 'Rain':
      return <IconSpeed __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} />;
    case 'Bumps':
      return <IconBumps __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} />;
    case 'Grip':
      return <IconGrip __css={{ path: { fill: tbd ? 'white.60' : 'white.80' } }} />;
      
  }
}

const ConditionItem = ({ type, variant, tbd = false }: ConditionItemProps) => {
  const config = conditionsConfig[type];
  const variantConfig = config.variants[variant];
  const Icon = conditionItemIcon(config.label, tbd);

  const getUnitText = (label: string, text: string) => {
    if (label === 'Air' || label === 'Track') {
      return `${text}ºC`;
    }
    if (label === 'Wind') {
      return `${text} KpH`;
    }
    return text;
  };

  return (
    <Flex
      background="linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.06) 100%)"
      borderRadius="4px"
      justifyContent="space-between"
      px="2"
      py="1"
      alignItems="center"
      flex={1}
    >
      <Flex gap={{ base: '1', md: '2' }} alignItems="center">
        {Icon}
        <Text
          fontSize={{ base: '12px', md: '14px' }}
          lineHeight={{ base: '12px', md: '14px' }}
          fontWeight="600"
          color={tbd ? 'white.60' : 'white.80'}
        >
          {config.label}
        </Text>
      </Flex>

      {tbd ? (
        <Flex
          background="rgba(255, 255, 255, 0.1)"
          borderRadius="4px"
        >
          <Text
            fontSize={{ base: '10px', md: '12px' }}
            lineHeight={{ base: '12px', md: '14px' }}
            fontWeight="600"
            p="1"
            color="white.80"
          >
            TBD
          </Text>
        </Flex>
      ) : (
        <ConditionRange 
          text={getUnitText(config.label, variantConfig.text)}
          textColor={variantConfig.textColor}
          backgroundColor={variantConfig.backgroundColor}
        />
      )}

      
    </Flex>
  )
}

export default ConditionItem;